import { EmailDto } from "../../dtos/user/EmailDto";
import { GetOneUserDto } from "../../dtos/user/GetOneUserDto";
import { getUserByEmail } from "../../service/user/userService";

export async function LoggedInUserData(dispatch: any): Promise<GetOneUserDto> {
    const loggedInUser: string | null = localStorage.getItem('user');
    const input: EmailDto = {
        email: loggedInUser as string
    }
    const data: GetOneUserDto = await getUserByEmail(dispatch, input);
    return data;
}